import '../styles/modal.css'
export const ModalBlur=()=>{
    return(
        <div className="modal_blur">

        </div>
    )
}